import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { IProfessionalTransfersReport } from '../interfaces/professional-transfers-report/iprofessionaltransfersreport';

@Injectable({
  providedIn: 'root'
})
export class ProfessionalTransfersReportService {

 /* url: string = 'http://localhost:3000/professional_transfers_report'; */

   url: string = 'https://api-fake-r9p5.onrender.com/professional_transfers_report'; 

  constructor(private http: HttpClient) { }

  get() {
    return this.http
      .get(this.url)
      .pipe(map((res: any) => res)) as Observable<IProfessionalTransfersReport>;
    //.pipe(map((res: any) => res['hydra:member'])) as Observable<IProfessionalTransfersReport>;
  }
}
